import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  ORDER_STATUS_LABEL,
  formatYuan,
  listMyOrders,
  type Order,
} from '../lib/api';

export default function MyOrders() {
  const [orders, setOrders] = useState<Order[]>([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    listMyOrders()
      .then((r) => setOrders(r.orders))
      .catch(() => setError('订单加载失败'))
      .finally(() => setLoading(false));
  }, []);

  return (
    <section className="stack">
      <div className="work-card">
        <h1 className="type-display-md text-ink">我的订单</h1>
        <p className="type-body-md text-ink-secondary">登录后可在此查看进度；订单仅对本人可见。</p>
        {error ? <div className="error">{error}</div> : null}
        {loading ? <p className="type-body-md text-ink-secondary">加载中…</p> : null}
        {!loading && orders.length === 0 ? (
          <p className="type-body-md text-ink-secondary">
            暂无订单。<Link to="/order/new">去选档下单</Link>
          </p>
        ) : null}
        {orders.length > 0 ? (
          <div className="admin-table-wrap">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>状态</th>
                  <th>订单号</th>
                  <th>档位</th>
                  <th>金额</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {orders.map((o) => (
                  <tr key={o.id}>
                    <td>{ORDER_STATUS_LABEL[o.status] ?? o.status}</td>
                    <td className="mono">{o.public_code}</td>
                    <td>{o.tier === 'deep' ? '深度' : '标准'}</td>
                    <td>{formatYuan(o.amount_cents)}</td>
                    <td>
                      <Link to={`/order/${o.public_code}`}>详情</Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : null}
      </div>
    </section>
  );
}
